import { LoggerTexts } from '../LoggerTexts';

export class PxApiError extends Error {
	constructor(message?: string) {
		const formattedMessage = message ? message.trim() : '';
		/* istanbul ignore next */ //Coverage works correctly with ES6
		super(formattedMessage);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, PxApiError);
		}
		this.name = 'PxApi.Error';
		let messageText = LoggerTexts.PXAPI_ERROR.ERROR_HEADER;
		if (formattedMessage && formattedMessage.length > 0) {
			messageText += ` ${formattedMessage}`;
		}
		this.message = messageText;
	}
}
